import { validateResendInvite } from "../../common/helpers/workspacePermissions";
import { useCurrentUserWorkspaceMember } from "./useCurrentUserWorkspaceMember";

export function useCanResendInvite() {
    const currentMember = useCurrentUserWorkspaceMember();
    return Boolean(currentMember && !validateResendInvite(currentMember));
}
